// extracted by mini-css-extract-plugin
export default {"root":"Dashboard_root__NOQ0x","table":"Dashboard_table__HQKeo","actions":"Dashboard_actions__B6rnh","separator":"Dashboard_separator__oaZjN"};